<!--<h1 *ngIf="!_originData" style="text-align: center; margin-top: 100px;">{{ feedbackMessage }}</h1>-->
<!--<div class="custom-container" *ngIf="_originData">-->
<div class="custom-container p-0">

  <div class="row justify-content-md-center m-0">
    <div class="col-lg-12 col-md-12 col-sm-12 p-0">

      <div class="automation-container">
        <div class="header-content">
          <!--<h1> Unisource </h1>-->
          <img src="assets/images/unisourceWhiteLogo.png" class="unisource-logo" alt="" />
          <h4>Unisource Order/Fees (ASO)</h4>
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-8 col-sm-8">
      <div class="card pt-2 rounded-0">

        <form class="example-form" [formGroup]="adminAutomatedOptionsForm" (ngSubmit)="confirmationOrder()">
          <div class="form-content">
            <div class="row justify-content-center">
              <div class="col-md-12">

                <div class="">
                  <!--<div class="card-header">Manage Template</div>-->
                  <div class="card-body" style="min-height: 400px;">

                    <div class="row justify-content-center">
                      <div class="col-lg-12 col-md-12 col-sm-12">

                        <div class="row">
                          <div class="col col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4 mt-2 text-center">
                            <h1>Manage Template</h1>
                            <p class="text-muted">Configure your automated order/Fees transaction preferences.</p>
                            <hr class="custom-hr" style="color: #dee2e6; margin-top: 13px;" />
                          </div>

                          <div class="col col-lg-6 col-md-6 col-sm-6">
                            <mat-label>Automated Template Name</mat-label>
                            <mat-form-field class="example-full-width">
                              <input matInput placeholder="" formControlName="templateName">
                              <mat-error *ngIf="adminAutomatedOptionsForm.get('templateName')?.invalid && adminAutomatedOptionsForm.get('templateName')?.touched">
                                {{ getErrorMessage(adminAutomatedOptionsForm.get('templateName')) }}
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col col-lg-6 col-md-6 col-sm-6">
                            <mat-label>Automated Template Type</mat-label>
                            <mat-form-field class="example-full-width">
                              <mat-select formControlName="templateType" [compareWith]="compareIdNameObj" (selectionChange)="onAutomatedTemplateTypeChange($event)">
                                <mat-option *ngFor="let option of templateTypeList" [value]="option">{{option.name}}</mat-option>
                              </mat-select>
                              <mat-error *ngIf="adminAutomatedOptionsForm.get('templateType')?.invalid && adminAutomatedOptionsForm.get('templateType')?.touched">
                                {{getErrorMessage(adminAutomatedOptionsForm.get('templateType'))}}
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col col-lg-6 col-md-6 col-sm-6 pr-4rem">
                            <mat-label>Transaction Type</mat-label>
                            <mat-form-field class="example-full-width">
                              <mat-select formControlName="transactionType" [compareWith]="compareIdNameObj" (selectionChange)="onOrderTransactionTypeChange($event)">
                                <mat-option *ngFor="let option of transactionTypeList" [value]="option">{{option.name}}</mat-option>
                              </mat-select>
                              <mat-error *ngIf="adminAutomatedOptionsForm.get('transactionType')?.invalid && adminAutomatedOptionsForm.get('transactionType')?.touched">
                                {{getErrorMessage(adminAutomatedOptionsForm.get('transactionType'))}}
                              </mat-error>
                            </mat-form-field>
                            <span class="material-icons title-popover-info-icon transactionTypePopoverSelector"
                                  data-toggle="popover"
                                  data-container="body"
                                  data-placement="top">info</span>
                          </div>
                          <div class="col col-lg-6 col-md-6 col-sm-6">
                            <mat-label>Product / Services</mat-label>
                            <mat-form-field class="example-full-width">
                              <mat-select formControlName="productServices" [compareWith]="compareIdNameObj">
                                <mat-option *ngFor="let option of productServiceList" [value]="option">{{option.name}}</mat-option>
                              </mat-select>
                              <mat-error *ngIf="adminAutomatedOptionsForm.get('productServices')?.invalid && adminAutomatedOptionsForm.get('productServices')?.touched">
                                {{getErrorMessage(adminAutomatedOptionsForm.get('productServices'))}}
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col col-lg-12 col-md-12 col-sm-12 text-right">
                            <button type="submit" class="btn btn-primary mr-3">
                              <span class="material-icons">save</span> Save
                            </button>
                            <button type="button" class="btn btn-outline-secondary" (click)="closeInteraction()">
                              <span class="material-icons">close</span> Cancel
                            </button>
                          </div>

                        </div>

                      </div>




                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </form>

        <footer class="admin-automated-options-footer">
          <!--<div class="footer-links">
            <a href="/contact" target="_blank">Contact Us</a> |
            <a href="/support" target="_blank">Support</a> |
            <a href="/faq" target="_blank">Privacy Policy</a> |
            <a href="/faq" target="_blank">Terms of Use</a>
          </div>-->
          <div class="footer-copy">
            &copy; 2026 Unisource. All rights reserved.
          </div>
        </footer>

      </div>
    </div>
  </div>


</div>


<div class="modal fade" id="transactionResponseAPIStatusModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 360px;">
    <div class="modal-content" style="padding: 8px 10px 2px;">
      <div class="modal-body">
        <h2 class="modal-title">Processing Request</h2>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <p class="mt-3">The EPC integration is taking longer than expected. <br>You may choose to wait or exit the transaction.</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="transactionNotRespondingWaitBtn()"><span class="material-icons">hourglass_top</span> Continue Waiting</button>
        <!-- <button type="button" class="btn btn-primary" (click)="onProcessDoneButtonClick()"><span class="material-icons">close</span> Exit</button> -->
        <button type="button" class="btn btn-secondary" [disabled]="isEPCNotRespondingLoading"
                (click)="onProcessDoneButtonClick()">
          <span *ngIf="!isEPCNotRespondingLoading" class="material-icons">close</span>
          <span *ngIf="isEPCNotRespondingLoading" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
          {{ isEPCNotRespondingLoading ? 'Loading...' : 'Exit' }}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- SESSION EXPIRED MODAL -->
<!--<div class="modal fade" id="sessionExpiredModal" tabindex="-1" aria-labelledby="sessionExpiredLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 390px;">
    <div class="modal-content" style="padding: 8px 10px 2px;">

      <div class="modal-body">
        <h2 class="modal-title">Session Expired</h2>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <p class="mt-3">Your session will expire in <span id="countdownValue" class="text-dark">60</span> seconds. Do you want to reset it ?</p>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-end">
        <button type="button" class="btn btn-secondary" [disabled]="isEPCNotRespondingLoading" (click)="onProcessDoneButtonClick()">
          <span *ngIf="!isEPCNotRespondingLoading" class="material-icons">close</span>
          <span *ngIf="isEPCNotRespondingLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ isEPCNotRespondingLoading ? 'Loading...' : 'No' }}
        </button>
        <button type="button" class="btn btn-primary" style="width: 108px" [disabled]="isSessionResetLoading" (click)="resetApp()">
          <span *ngIf="!isSessionResetLoading" class="material-icons">restore</span>
          <span *ngIf="isSessionResetLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ isSessionResetLoading ? 'Loading...' : 'Reset' }}
        </button>
      </div>
    </div>
  </div>
</div>-->
